import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css"; // Required for styling
import $ from "jquery"; // Required for jQuery to work with DataTable
import "datatables.net"; // Import DataTable jQuery plugin

function Rewards() {
  const navigate = useNavigate();
  const location = useLocation(); // Access the current location (URL)
  const [requestData, setRequestData] = useState([]); // Initialize as an empty array
  const [total, setTotal] = useState([]); // Initialize as an empty array
  const [dataTable, setDataTable] = useState(null);
  
  // Extract query parameter 'id' from the URL
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id"); // Get the 'id' from the query string

  useEffect(() => {
    fetchData();
  }, []);
useEffect(() => {
  // Initialize DataTable once
  if (!dataTable) {
    const table = $('#rewards').DataTable({
      serverSide: true,
      processing: true,
      ordering: true, // Enable ordering
      order: [[3, 'desc']], // Default sort by createdAt column (descending)
      ajax: function (data, callback, settings) {
        const page = settings._iDisplayStart / settings._iDisplayLength + 1;
        const search = data.search.value || '';
        const length = data.length || '';

        let orderColumn = 'createdAt';
        let orderDir = 'desc';

        // Only override defaults if valid order data exists
        try {
          if (
            data.order &&
            data.order[0] &&
            settings.aoColumns &&
            settings.aoColumns[data.order[0].column]
          ) {
            const column = settings.aoColumns[data.order[0].column];
            if (column.name) {
              orderColumn = column.name;
              orderDir = data.order[0].dir;
            }
          }
        } catch (error) {
          console.log('Sorting error handled:', error);
        }

        console.log('orderColumn', orderColumn);
        console.log('orderDir', orderDir);

        fetchData(page, search, length, orderColumn, orderDir).then((response) => {
          // If no records found, set empty data
          if (response.data.length === 0) {
            callback({
              draw: response.draw,
              recordsTotal: 0,
              recordsFiltered: 0,
              data: [], // No records found
            });
          } else {
            callback({
              draw: response.draw,
              recordsTotal: response.recordsTotal,
              recordsFiltered: response.recordsFiltered,
              data: response.data,
            });
          }
        });
      },
      columns: [
        {
          data: null,
          orderable: false,
          render: (data, type, row, meta) => meta.row + 1,
        },
        {
            data: 'rewards_type',
            name: 'rewards_type',
            orderable: true,
            render: (data) => {
              if (data === "geotag_hunting_rewards") {
                return "Hunted Geotag";
              } else if (data === "user_referred_rewards") {
                return "Referred New User Sign Up";
              } else if (data === "user_signup_rewards") {
                return "Your SignUp Rewards";
              } else {
                return data || 'N/A';
              }
            },
          },
        {
          data: 'rewards_points',
          name: 'rewards_points',
          orderable: true,
          render: (data) => data || 'N/A', // Business name from business object
        },
        {
          data: 'createdAt', 
          name: 'createdAt',
          orderable: true,
          render: (data) => new Date(data).toLocaleString() || 'N/A', // CreatedAt date
        },
      ],
      pageLength: 10,
      lengthMenu: [10, 25, 50, 75, 100],
      responsive: true,
      searching: true,
      paging: true,
      language: {
        emptyTable: "No records found", // Custom message when no data is found
      },
      drawCallback: function (settings) {
        // Set default sort only on first draw
        if (settings._iDisplayStart === 0 && !this.api().order().length) {
          this.api().order([6, 'desc']).draw();
        }
      },
    });

    setDataTable(table); // Store DataTable instance
  }

  // Cleanup DataTable when the component is unmounted
  return () => {
    if (dataTable) {
      dataTable.clear().destroy();
    }
  };
}, [dataTable]); // Only initialize once


  const fetchData = async (page, search = "", length = "", orderColumn = "", orderDir = "") => {
    try {
      const limit = length || 10; // Limit per page
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "userRewardTransactions",
          module: "user",
          index: page,
          limit: limit,
          search: search, // Send search term if available
          orderColumn: orderColumn,
          orderDir: orderDir,
          userId: userId ? userId : "", // Pass the businessId in the request (if needed)
        }),
      });

      const data = response.data;
      console.log("jjj");
      console.log(response);
      if (data.statusCode === 200) {
        setRequestData(data.result.rewardsDetails || []); 
        setTotal(data.result.totalRewardsPoints || 0)
        const rewards = data.result.rewardsDetails;
        const totalrewards = data.result.pagination.totalTransactions; // Get total users count

        return {
          draw: data.draw, // Draw counter for DataTable
          recordsTotal: totalrewards, // Total records (from API)
          recordsFiltered: totalrewards, // Filtered records (can be same if no filters)
          data: rewards, // Data for the current page
        };
      } else if (data.statusCode === 400 && data.code === "data_not_found") {
        // Handle data_not_found error
        return {
          draw: 0,
          recordsTotal: 0,
          recordsFiltered: 0,
          data: [], // No data found
        };
      } else {
        console.error("Failed to fetch users:", data);
        return {
          draw: 0,
          recordsTotal: 0,
          recordsFiltered: 0,
          data: [],
        };
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return {
        draw: 0,
        recordsTotal: 0,
        recordsFiltered: 0,
        data: [],
      };
    }
  };
 
 

  return (
    <div className="wrapper">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">GeoCredits - ({total}) </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                {/* Conditional rendering for "No records" message */}
               
                  <div className="table-responsive">
                    <table
                      id="rewards"
                      className="table table-striped table-bordered txt_lft display"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Type</th>
                          <th>Credits</th>
                          <th>CreatedAt</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Data rows will be populated by DataTable */}
                      </tbody>
                    </table>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Rewards;
